





















import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";

@Component
export default class Heading extends Vue {
  private items = [
    {
      src: "https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg"
    }
  ];
}
